
/*
  **************************************************************************
  action js
  **************************************************************************
*/

/**
 *
 * @type {{}}
 */
const action = {};

/**
 * main variable
 * @param data
 */
var actionVariable = {
    // todo
    contentStyle: null, // 内容区域 长宽
};

export default action;



// WEBPACK FOOTER //
// ./src/assets/js/action.js